import { getAuthTokens } from "./cookieUtils";

// Decodes a JWT payload (base64url) without validating the signature.
// The backend is the source of truth for authorization; this is UI-only.
export const decodeJwtPayload = (token) => {
  if (!token) return null;
  try {
    const payloadB64 = token.split(".")[1];
    if (!payloadB64) return null;
    const base64 = payloadB64.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join("")
    );
    return JSON.parse(json);
  } catch (error) {
    console.error("Failed to decode JWT payload:", error);
    return null;
  }
};

export const getCurrentUserClaims = () => {
  const tokens = getAuthTokens();
  return decodeJwtPayload(tokens?.idToken);
};

export const isCurrentUserAdmin = () => {
  const groups = getCurrentUserClaims()?.["cognito:groups"] || [];
  return Array.isArray(groups) && groups.includes("admin");
};

